import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var TimeoutManager = /*#__PURE__*/function () {
  function TimeoutManager() {
    _classCallCheck(this, TimeoutManager);
  }
  return _createClass(TimeoutManager, null, [{
    key: "set",
    value: function set(key, callback, delay) {
      var _this = this;
      this.clear(key);
      var timerId = setTimeout(function () {
        callback();
        _this.timers.delete(key);
      }, delay);
      this.timers.set(key, timerId);
    }
  }, {
    key: "clear",
    value: function clear(key) {
      var timerId = this.timers.get(key);
      if (timerId) {
        clearTimeout(timerId);
        this.timers.delete(key);
      }
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.timers.forEach(function (timerId) {
        return clearTimeout(timerId);
      });
      this.timers.clear();
    }
  }]);
}();
TimeoutManager.timers = new Map();
export default TimeoutManager;